import { Grid, Box } from "@mui/material";
import styles from "../ServicesMenu/services.module.scss";
import { useState } from "react";

const YoungAdultActivity = () => {
  const [showMoreContent, setShowMoreContent] = useState(false);

  return (
    <Box className={styles.YoungadultactivitytotalLaout}>
      <Box
        component="img"
        sx={{ width: { xs: "100%", md: "80%", lg: "60%" }, borderRadius: "6px" }}
        src={`${process.env.REACT_APP_BASE_ASP_URL}/hints/youngadults/2024/YoungAdultServices.jpg`}
      />
      <Box
        component="img"
        sx={{ width: { xs: "100%", md: "80%", lg: "60%" }, mt: "20px", borderRadius: "6px" }}
        src={`${process.env.REACT_APP_BASE_ASP_URL}/hints/youngadults/2024/YoungAdultServices2.jpg`}
      />
      <Box
        component="img"
        sx={{ width: { xs: "100%", md: "80%", lg: "60%" }, mt: "20px", borderRadius: "6px" }}
        src={`${process.env.REACT_APP_BASE_ASP_URL}/hints/youngadults/2024/HCCCYoungAdults_MentoringProgram_Teaser.jpg`}
      />
      <Box
        component="img"
        sx={{ width: { xs: "100%", md: "80%", lg: "60%" }, mt: "20px", borderRadius: "6px" }}
        src={`${process.env.REACT_APP_BASE_ASP_URL}/hints/youngadults/2024/HCCC_YoungAdults_VolunteerCampaign_01.01.24.jpg`}
      />
    </Box>
  );
};
export default YoungAdultActivity;
